/**
 * Component to register Easy Post.
 *
 * @component
 */

import React from 'react';
import { Modal, Input, message, Row, Col, Divider } from 'antd';
import axios from 'axios';
import { trackingVitally } from '../../../../../helpers/vitally';
const LABEL_SERVICE = 'easypost';

class EasypostModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      active: false,
      labelApiKey: null,
      loading: false,
    };
  }

  async componentDidMount() {
    try {
      const response = await axios.get(`/api/carrierSettings/${LABEL_SERVICE}`);
      if (response.data) {
        const { carrier } = response.data;
        this.setState({
          id: carrier.id,
          active: carrier.active,
          labelApiKey: carrier.labelApiKey,
        });
      }
    } catch (err) {
      if (err?.response?.status !== 404) {
        console.log(err);
        message.error('something went wrong please try again', 5);
      }
    }
  }

  validateFields = () => {
    const { labelApiKey } = this.state;
    if (!labelApiKey || labelApiKey === '') {
      message.error('API Key is required.');
      return false;
    }
    return true;
  };

  getPayload = () => {
    const { id, active, labelApiKey } = this.state;
    return {
      id,
      active,
      labelApiKey,
      labelService: LABEL_SERVICE,
    };
  };

  handleOk = async () => {
    this.setState({
      loading: true,
    });
    if (!this.validateFields()) {
      this.setState({
        loading: false,
      });
      return;
    }
    const payload = this.getPayload();
    trackingVitally('rr_Easypost_integrated');
    try {
      const response = await axios.post('/api/carrierSettings/update', payload);
      console.log(response);
      message.success('Easy Post integration has been successfully set up', 5);
      this.props.setModalVisible(null);
    } catch (err) {
      this.setState({
        loading: false,
      });
      return message.error('something went wrong please try again', 5);
    }
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  render() {
    return (
      <Modal
        title="Set up your Easy Post integration"
        visible={true}
        width="50%"
        onOk={this.handleOk}
        confirmLoading={this.state.confirmLoading}
        onCancel={() => this.props.setModalVisible(null)}
      >
        <Row type="flex" justify="space-around" align="middle">
          <Col span={10}>
            <h4 data-intercom-target="api-key-heading-integrations-carriers-easypost">API Key</h4>
            <span>
              EasyPost requires the 'Production API Key'{' '}
              <a
                href="https://www.easypost.com/account/api-keys"
                target="_blank"
                rel="noopener noreferrer"
              >
                you can find here in your EasyPost account
              </a>
              . The 'Test API Key' will not work.
            </span>
          </Col>
          <Col span={10}>
            <a
              href="https://www.easypost.com/account/api-keys"
              target="_blank"
              rel="noopener noreferrer"
            >
              You can find here in your EasyPost account
            </a>
            <br />
            {/* {this.props.inputFieldValidation === false && (
              <p style={{ color: '#f00000' }}>
                API key cannot contain "API", "test", "sandbox" or special
                characters
              </p>
            )} */}
            <Input
              name="labelApiKey"
              onChange={(e) => this.handleChange('labelApiKey', e.target.value)}
              value={this.state.labelApiKey}
              data-intercom-target="api-key-input-integrations-carriers-easypost"
            />
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default EasypostModal;
